<template>
  <ActionInfoFilledIcon
    class="infoIcon"
    @click.prevent="handleClick"
  />
</template>

<script>
import ActionInfoFilledIcon from '~/assets/icons/action_info_filled.svg?component'

export default {
  components: {
    ActionInfoFilledIcon
  },
  props: {
    popupRef: {
      type: String,
      default() {
        return null
      }
    },
    url: {
      type: String,
      default() {
        return null
      }
    }
  },
  methods: {
    handleClick() {
      if (this.popupRef) {
        this.$eventbus.emit(this.popupRef)
      } else if (this.url) {
        window.open(this.url, '_blank')
      }
    }
  }
}
</script>

<style lang="scss">
.icon.infoIcon {
  position: relative;
  cursor: pointer;
  font-size: 1.25rem;
  color: $color__primary;
}

</style>
